import { render, staticRenderFns } from "./courseCenter.vue?vue&type=template&id=d16d1fec"
import script from "./courseCenter.vue?vue&type=script&lang=js"
export * from "./courseCenter.vue?vue&type=script&lang=js"
import style0 from "./courseCenter.vue?vue&type=style&index=0&id=d16d1fec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports